/**
 * Route configuration for the DP Portal
 */

// Destination to route mapping
export const DESTINATION_ROUTES = {
    DASHBOARD: '/dashboard',
    CONSENT_DETAILS: '/consents',
    NOTICE_FORM: '/consents', // Will be enhanced later to show specific notice form
    NOTICE_DETAILS: '/notices', // Notice details page (assignmentId will be appended in URL)
    DOUBLE_OPT_IN: '/consents', // Will be enhanced later to show consent form again
    PURPOSE_DETAILS: '/purposes', // Future
    DATA_DETAILS: '/data', // Future
} as const;

// Type for destination keys
export type DestinationType = keyof typeof DESTINATION_ROUTES;

/**
 * Get route for a destination
 */
export const getRouteForDestination = (destination: string | null): string => {
    if (!destination) {
        return DESTINATION_ROUTES.DASHBOARD;
    }

    return DESTINATION_ROUTES[destination as DestinationType] || DESTINATION_ROUTES.DASHBOARD;
};

/**
 * Route definitions for the portal
 */
export const ROUTES = {
    // Authentication
    AUTHENTICATE: '/authenticate',
    LOGIN: '/login',

    // Main portal routes
    DASHBOARD: '/dashboard',
    CONSENTS: '/consents',
    PURPOSES: '/purposes',
    DATA: '/data',
    IDENTIFIERS: '/identifiers',
    NOTICES: '/notices',
    REQUESTS: '/requests',
    SUPPORT: '/support',

    // Legacy routes
    MANAGE_CONSENT: '/manage-consent',
} as const;

/**
 * Route metadata for navigation
 */
export const ROUTE_METADATA = {
    [ROUTES.DASHBOARD]: {
        title: 'Dashboard',
        description: 'Overview of your privacy portal',
        icon: 'dashboard',
    },
    [ROUTES.CONSENTS]: {
        title: 'Forms',
        description: 'View your consent history and form details',
        icon: 'description',
    },
    [ROUTES.PURPOSES]: {
        title: 'Purposes',
        description: 'Manage your consent for different purposes',
        icon: 'assignment',
    },
    [ROUTES.DATA]: {
        title: 'Data',
        description: 'View and manage your personal data',
        icon: 'storage',
    },
    [ROUTES.IDENTIFIERS]: {
        title: 'Identifiers',
        description: 'Manage your linked identifiers',
        icon: 'account_circle',
    },
    [ROUTES.NOTICES]: {
        title: 'Notices',
        description: 'View and respond to notices',
        icon: 'notifications',
    },
    [ROUTES.REQUESTS]: {
        title: 'Requests',
        description: 'Track your privacy requests',
        icon: 'track_changes',
    },
    [ROUTES.SUPPORT]: {
        title: 'Support',
        description: 'Get help and contact support',
        icon: 'help',
    },
} as const;
